/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Submitted_ToastInputs */



/**
* | output |
* | --- |
* | "Embed job submitted successfully" |
*
* @param {Embed_Captions_Submitted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_submitted_toast = /** @type {((inputs?: Embed_Captions_Submitted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Submitted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tache d'incrustation soumise avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einbettungsauftrag erfolgreich übermittelt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorpora lavoro inviato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Задание на встраивание успешно отправлено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Trabajo insertado enviado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("嵌入式作业已成功提交")
	if (locale === "ja") return /** @type {LocalizedString} */ ("埋め込みジョブが正常に送信されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एम्बेड जॉब सफलतापूर्वक सबमिट हो गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Trabalho incorporado submetido com sucesso")
	return /** @type {LocalizedString} */ ("Embed job submitted successfully")
});